import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import * as yup from 'yup'
import { Formik, Form, FormikProps } from 'formik'
import { HandleMassSubmissionFunction } from '../types'
import { selectSidebarStep, REVIEW_MODAL_TYPE } from 'state/review'
import { STEP_TYPE_ENUM } from 'services/api/constants'
import _ from 'lodash'
import Modal from 'particles/Modal'
import { FormikTextArea } from 'particles/TextInputs/TextArea'
import styled from 'particles/themes/styled'
interface FormValues {
    comment: string
}
const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[400]};
`

interface MassRejectAndEditModalProps {
    selectedNum: number
    handleAction?: HandleMassSubmissionFunction
    setOpen: (value: boolean) => void
    type: REVIEW_MODAL_TYPE
}

const MassRejectAndEditModal: React.FC<MassRejectAndEditModalProps> = ({
    selectedNum,
    handleAction,
    setOpen,
    type,
}) => {
    const [t] = useTranslation()
    const sidebarStep = useSelector(selectSidebarStep)
    const formikRef = useRef<FormikProps<FormValues>>(null)

    const validation = yup.object({
        comment: yup
            .string()
            .max(10000, ({ max }) =>
                t('errorMessage.validation.enterLessThanCharacterLimit', 'Please enter less than {{max}} characters.', {
                    max,
                }),
            )
            .nullable()
            .required(t('errorMessage.validation.enterRequestEditReason')),
    })

    const handleConfirm = () => {
        if (formikRef.current) {
            formikRef.current.submitForm()
        }
    }

    return (
        <Modal
            title={
                type === REVIEW_MODAL_TYPE.EDIT_REQUEST
                    ? t('modalWindow.confirmationMessage.requestEditTitle', {
                          selectedNum,
                      })
                    : t('modalWindow.confirmationMessage.rejectPartiposterTitle', {
                          selectedNum,
                      })
            }
            subtext={
                sidebarStep &&
                [
                    STEP_TYPE_ENUM.SUBMIT_PROOF_IG_SCREENSHOT,
                    STEP_TYPE_ENUM.SUBMIT_ENGAGEMENT_RESULTS_AND_PROOF_IG_SCREENSHOT,
                ].includes(sidebarStep.type)
                    ? type === REVIEW_MODAL_TYPE.EDIT_REQUEST
                        ? t('modalWindow.confirmationMessage.turnOffMultiSelectSubtitle')
                        : t('modalWindow.confirmationMessage.turnOffMultiSelectSubtitle')
                    : type === REVIEW_MODAL_TYPE.EDIT_REQUEST
                      ? t('modalWindow.confirmationMessage.requestEditFromPartipostersBulkSubtitle', {
                            count: selectedNum,
                        })
                      : t('modalWindow.confirmationMessage.rejectPartipostersBulkSubtitle', {
                            count: selectedNum,
                        })
            }
            hasIcon={false}
            size="m"
            primaryButtonProps={{
                label: type === REVIEW_MODAL_TYPE.EDIT_REQUEST ? t('button.requestEditsForAll') : t('button.rejectAll'),
            }}
            secondaryButtonProps={{
                label: t('button.cancel'),
            }}
            onConfirm={() => {
                handleConfirm()
            }}
            onClose={() => setOpen(false)}
        >
            <Formik
                innerRef={formikRef}
                initialValues={{ comment: '' }}
                enableReinitialize={true}
                validationSchema={validation}
                onSubmit={values => {
                    if (handleAction) {
                        handleAction({ comment: values.comment })
                    }
                }}
            >
                <Form>
                    <Container>
                        <FormikTextArea
                            name="comment"
                            placeholder={t('placeholderText.enterCommentForPartiposter')}
                            minTextAreaHeight={100}
                            maxTextAreaHeight={200}
                        />
                    </Container>
                </Form>
            </Formik>
        </Modal>
    )
}

export default MassRejectAndEditModal
